import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

// Import the Redux store and Provider
import { Provider } from 'react-redux';
import store from './Redux/store';
import { AuthProvider } from './Redux/AuthContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <AuthProvider>
      <App />
    </AuthProvider>
  </Provider>
);

// Unregister service worker in development to prevent stale cached bundle serving
serviceWorkerRegistration.unregister();

reportWebVitals();
